import { injectable, inject } from 'inversify'

import { RoutingService } from '#AltServices'

@injectable()
export class CartRoutingService {
  constructor(@inject(RoutingService) readonly router: RoutingService) {}

  get index() {
    return this.router.createRouteData({ name: 'CartIndex' })
  }
}
